import _axios from '../../apiClient'

export function setCantidadDiasTurnero(payload) {

    return _axios.post(`/api/Turnero/SetCantidadDiasTurnero`,
        payload,  
    { 
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getCalendariosTurnero(payload) {

    return _axios.get(`/api/Turnero/GetCalendariosTurnero?idInstalacion=${payload.idInstalacion}`,
    {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function eliminarCalendarioTurnero(payload) {

    return _axios.post(`/api/Turnero/EliminarCalendarioTurnero`,
    payload,
    {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function saveCalendarioHorario(payload) {

    return _axios.post(`/api/Turnero/SaveCalendarioHorario`,
    payload,
    {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function eliminarCalendarioNoLaborable(payload) {

    return _axios.post(`/api/Turnero/EliminarCalendarioNoLaborable`,
    payload,
    {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function saveCalendarioNoLaborable(payload) {

    return _axios.post(`/api/Turnero/SaveCalendarioNoLaborable`,
    payload,
    {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}